// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    ItemResponse,
    ItemResponseFromJSON,
    ItemResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface SearchResults
 */
export interface SearchResults {
    /**
     * 
     * @type {number}
     * @memberof SearchResults
     */
    count: number;
    /**
     * 
     * @type {Array<ItemResponse>}
     * @memberof SearchResults
     */
    results: Array<ItemResponse>;
    /**
     * 
     * @type {any}
     * @memberof SearchResults
     */
    aggregations: any;
}

export function SearchResultsFromJSON(json: any): SearchResults {
    return {
        'count': json['count'],
        'results': (json['results'] as Array<any>).map(ItemResponseFromJSON),
        'aggregations': (json['aggregations']),
    };
}

export function SearchResultsToJSON(value?: SearchResults): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'count': value.count,
        'results': (value.results as Array<any>).map(ItemResponseToJSON),
        'aggregations': (value.aggregations),
    };
}


